import { PressureIndependentValveTypes, ValveType } from './ValveTypes';

export function checkOCCO(operationModes: string[]) {
    return [
        'Open/close',
        'On/off',
        'Changeover',
    ].filter((v) => (operationModes || []).includes(v)).length === 0;
}

export function isSteam(Fluid: string[]) {
    return (Fluid || []).includes('Steam');
}

export function checkPd(shortValveType: ValveType[]) {
    return PressureIndependentValveTypes.filter((v) => (shortValveType || []).includes(v)).length > 0;
}

export function check6Way(shortValveType: string[]) {
    return (shortValveType || [])
    .filter((v) => v.toLowerCase().includes('6-way'))
        .length > 0;
}

export function check3Way(shortValveType: string[]) {
    return (shortValveType || [])
    .filter((v) => v.toLowerCase().includes('3-way'))
        .length > 0;
}
